import React from 'react';
import Header from './Header';
import Menu from './Menu';
import Footer from './Footer';
import ToTopButton from './ToTopButton';
import useTemplateScripts from '../hooks/useTemplateScripts';
import useLanguageFromUrl from '../hooks/useLanguageFromUrl';

const Layout = ({ children }) => {
    // Inicializar scripts del template
    useTemplateScripts();

    // Detectar y aplicar idioma desde la URL automáticamente
    useLanguageFromUrl();

    return (
        <>
            <Menu />
            <Header />
            <main id="mxd-page-content" className="mxd-page-content">
                {children}
            </main>
            <Footer />
            <ToTopButton />
        </>
    );
};

export default Layout;
